export default function calcTimeOnField(
  time: number,
  processedArea: number,
  totalProcessedArea: number,
): number | null {
  if (!time || totalProcessedArea === 0) return null;

  return (time * processedArea) / totalProcessedArea;
}
